import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { UserManager } from 'oidc-client';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import { CommunicationProxyService } from '../../services/communication-proxy.service';
import { KeyboardService } from '../../services/keyboard.service';
import { LoginService } from '../../services/login.service';
import { BaseComponent } from '../base/base.component';
import { StringTableService } from './../../../core/services/string-table.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-engine',
  styleUrls: ['./engine.component.scss'],
  templateUrl: './engine.component.html'

})
export class EngineComponent extends BaseComponent implements OnInit {

  /**
   * initially set to true cause we are loading all json objects
   */
  public static loaderVisible = true;

  /**
   * set to true in Login service
   */
  public static userLoggedIn = false;

  public static origin;
  public static firstLoad = 0;

  public static cdrStatic: ChangeDetectorRef;

  /**
   * json containing the endpoints of the api
   */
  public endPoints: any;

  private dialogSuccessCallback: Function;

  /**
   * Data to be show in modal.
   */
  private modalData: {
    title: string
    body: string
  };

  /**
   * Is true when the dialog type is retry.
   */
  public retryPopup = false;

  /**
   * Controls the visibility of the dialog.
   */
  public dialogVisible = false;

  constructor(private loginService: LoginService, private elementRef: ElementRef, private http: Http,
    private stringTableService: StringTableService, private cdr: ChangeDetectorRef,
    private remoteProxy: CommunicationProxyService, private keyboardService: KeyboardService,
    private route: ActivatedRoute) {
    super(elementRef);
    EngineComponent.cdrStatic = this.cdr;
  }

  /**
  *
  * Shows the loader by setting the show loader flag in AppComponent to true
  * @static
  * @memberof EngineComponent
  */
  static showLoader() {
    EngineComponent.loaderVisible = true;
    EngineComponent.cdrStatic.detectChanges();
  }

  /**
   *
   * Hides the loader by setting the show loader flag in AppComponent to false
   * @static
   * @memberof EngineComponent
   */
  static hideLoader() {
    EngineComponent.loaderVisible = false;
    EngineComponent.cdrStatic.detectChanges();
  }

  ngOnInit() {
    this.loadEndpoint();
    this.route.queryParams.filter(x => x.system).subscribe(x => {
      EngineComponent.origin = x.system;
    });
  }

  loadEndpoint() {
    this.http.get('/assets/json/metadata.json')
      .subscribe(this.handleEndpointSubscription.bind(this));
  }

  get loaderVisibility() {
    return EngineComponent.loaderVisible;
  }

  get isUserLoggedIn() {
    return EngineComponent.userLoggedIn;
  }

  private handleEndpointSubscription(data) {
    const metadata: any = data.json();

    // Checking if the user is coming from NEOGOV/TGO website.
    // If true then adds link to NEOGOV/TGO website on Home page.
    if(EngineComponent.firstLoad === 0) {
      if(EngineComponent.origin === "0" || EngineComponent.origin === "1") {
        window.localStorage.setItem('origin', EngineComponent.origin);
      } else {
        EngineComponent.origin = window.localStorage.getItem('origin');
        window.localStorage.removeItem('origin');
      }
      EngineComponent.firstLoad = 1;
    } else {
      window.localStorage.removeItem('origin');
    }
    const origin = EngineComponent.origin;
    const keys = Object.keys(metadata.localize.originData);
    for (const key of keys) {
      if (origin === key) {
        metadata.localize.trainingManagement.push(metadata.localize.originData[origin].buttonData);
        metadata.localize.externalLinks.origin = metadata.localize.originData[origin].link;
      }
    }

    this.endPoints = metadata.endPoints;
    this.stringTableService.setLocalisationStrings(metadata.localize);
    this.stringTableService.setEndPoints(metadata.endPoints);
    this.loginService.createOidcManager(this.endPoints.OidcConfiguration);
    this.remoteProxy.setEndpointBaseUrl();
    this.loginService.login()
      .subscribe(this.getClientIdFromApi.bind(this));
  }

  /**
  * Calls the API to retrieve the client ID from the API.
  */
  private getClientIdFromApi() {
    this.remoteProxy.read(this.endPoints.GetClientIdFromUserId, { userId: this.loginService.getUserId() })
      .subscribe(
      this.saveClientId.bind(this),
      this.handleGetClientIdError.bind(this, this.getClientIdFromApi.bind(this))
      );
    this.stringTableService.allowGetReq = false;
  }

  /**
 * The success handler for the get client id from user id api.
 * @param clientIdSuccessResponseObj the respose object received from the server.
 */
  saveClientId(clientIdSuccessResponseObj: { clientId: string, response: string }) {
    EngineComponent.hideLoader();
    this.loginService.adminClientId = clientIdSuccessResponseObj.clientId;
    this.loginService.currentUserClientId = clientIdSuccessResponseObj.clientId;
    EngineComponent.userLoggedIn = true;
  }

  handleGetClientIdError(failedFunction, error) {
    let dataForDialog = {
      title: '',
      body: ''
    };
    if (error.status === 500 || error.status === 404) {
      dataForDialog = {
        title: this.stringTableService.getString('popupMessages', 'genericServerError') + ' ' + error.status,
        body: ''
      };
    } else {
      dataForDialog = {
        title: this.stringTableService.getString('popupMessages', 'serverErrorTitle'),
        body: this.stringTableService.getString('popupMessages', 'serverErrorData')
      };
    }
    EngineComponent.hideLoader();
    this.retryPopup = true;
    this.showDialog(dataForDialog, () => {
      this.retryPopup = false;
      failedFunction();
    });
  }

  /**
 * shows the dialog
 * @param modalInfo contains the info which we want to show in the modal component
 */
  showDialog(modalInfo: {
    title: string
    body: string
  }, onCloseSuccess?: Function) {
    if (onCloseSuccess) {
      this.dialogSuccessCallback = onCloseSuccess;
    }
    this.modalData = modalInfo;
    this.dialogVisible = true;
  }

  /**
   * hides the dialog
   */
  hideDialog(isSuccessCallbackCalled?) {
    if (isSuccessCallbackCalled) {
      this.dialogSuccessCallback();
    }
    this.modalData = {
      title: '',
      body: ''
    };
    this.dialogVisible = false;
    this.retryPopup = false;
  }
}

enum ModuleType {
  LOGIN = 0,
  FORGOT_PASSWORD = 1,
  HOME = 2
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/engine/engine.component.ts